<div [hidden]="appService.isLoading | async">
  <span>Patients:</span>
  <br />
  <br />
  <label>Search: &nbsp;</label>
  <input type="text" name="query" [(ngModel)]="query" placeholder="Search by uniqueid" />
  <br />
  <br />
  <div class="elso-grid">
    <div class="elso-grid-row" *ngFor="let patient of (allPatients | elsoGridFilter:query |
                         slice: paginatorService.lowValue : paginatorService.highValue)">
      <div>
        <div class="control-item">
          <span class="elso-grid-label">Unique id: </span>
          <span>{{patient.UniqueId}}</span>
        </div>
        <div class="control-item">
          <span class="elso-grid-label">Birthdate: </span>
          <span>{{patient.Birthdate | dateFormat}}</span>
        </div>
        <br />
        <button class="form-execute-buttons" (click)="deletePatient(patient.PatientId)" type="button" color="primary" mat-raised-button>
          <mat-icon>delete</mat-icon>
          Delete patient
        </button>
      </div>
      <div>Hospitalizations:</div>
      <br />
      <div class="elso-grid" style="width: 100%;">
        <div *ngFor="let hospitalization of patient.Hospitalizations" class="elso-grid-row">

          <div class="control-item">
            <span class="elso-grid-label">Hospitalization no: </span>
            <span>{{hospitalization.HospitalizationNo}}</span>
          </div>

          <div class="control-item">
            <span class="elso-grid-label">Hospital Admit Date: </span>
            <span>{{hospitalization.AdmitDate | dateFormat}}</span>
          </div>
          <br />
          <button class="form-execute-buttons" (click)="deleteHospitalization(hospitalization.HospitalizationId, patient.PatientId)" type="button" color="primary" mat-raised-button>
            <mat-icon>delete</mat-icon>
            Delete hospitalization
          </button>

          <br />
          <div>Runs:</div>
          <br />
          <div class="elso-grid" style="width: 100%;">
            <div *ngFor="let run of hospitalization.Runs" class="elso-grid-row">
              <div class="control-item">
                <span class="elso-grid-label">Run no: </span>
                <span>{{run.RunNo}}</span>
              </div>
              <div class="control-item">
                <span class="elso-grid-label">Age: </span>
                <span>{{appService.getFormatedStringFromDays(run.Age)}}</span>
              </div>
              <div class="control-item">
                <span class="elso-grid-label">Time on: </span>
                <span>{{run.TimeOn | dateFormat}}</span>
              </div>
              <div class="control-item">
                <span class="elso-grid-label">Time off: </span>
                <span>{{run.TimeOff | dateFormat}}</span>
              </div>
              <br />
              <button class="form-execute-buttons" (click)="deleteRun(run.RunId, hospitalization.HospitalizationId, patient.PatientId)" type="button" color="primary" mat-raised-button>
                <mat-icon>delete</mat-icon>
                Delete run
              </button>
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  </div>

  <br />
  <br />
  <mat-paginator *ngIf="allPatients" [length]="allPatients.length" pageSize=5
                 (page)="paginatorService.getPaginatorData($event)" [pageSizeOptions]="[5, 20, 30]"
                 showFirstLastButtons="false">
  </mat-paginator>
</div>



<!--<div [hidden]="appService.isLoading | async">
  <span>ECLS Runs:</span>
  <br />
  <br />
  <label>Search: &nbsp;</label>
  <input type="text" name="query" [(ngModel)]="query" placeholder="Search by uniqueid" />
  <br />
  <br />
  <div class="elso-grid">
    <div class="elso-grid-row" *ngFor="let run of (allRuns | elsoGridFilter:query |
                         slice: paginatorService.lowValue : paginatorService.highValue)">
      <div>
        <button class="form-execute-buttons" (click)="deleteRun(run.RunId)" type="button" color="primary" mat-raised-button>
          <mat-icon>delete</mat-icon>
          Delete run
        </button>
        <button class="form-execute-buttons" (click)="deletePatient(run.PatientId)" type="button" color="primary" mat-raised-button>
          <mat-icon>delete</mat-icon>
          Delete patient
        </button>
      </div>
      <div>
        <span class="elso-grid-label">Unique id: </span>
        <span>{{run.UniqueId}}</span>
      </div>
      <div>
        <span class="elso-grid-label">Run no: </span>
        <span>{{run.RunNo}}</span>
      </div>
      <div>
        <span class="elso-grid-label">Birthdate: </span>
        <span>{{run.Birthdate | dateFormat}}</span>
      </div>
      <div>
        <span class="elso-grid-label">Age: </span>
        <span>{{appService.getFormatedStringFromDays(run.Age)}}</span>
      </div>
      <div>
        <span class="elso-grid-label">Time on: </span>
        <span>{{run.TimeOn | dateFormat}}</span>
      </div>
      <div>
        <span class="elso-grid-label">Time off: </span>
        <span>{{run.TimeOff | dateFormat}}</span>
      </div>
    </div>
  </div>

  <br />
  <br />
  <mat-paginator *ngIf="allRuns" [length]="allRuns.length" pageSize=5
                 (page)="paginatorService.getPaginatorData($event)" [pageSizeOptions]="[5, 20, 30]"
                 showFirstLastButtons="false">
  </mat-paginator>
</div>-->
